<template>
  <div style="height:100%;background:#fff;border-radius:4px;padding:24px">
    <div>
      <span style="color:rgba(18, 18, 18, 1);font-size:16px;font-weight:bold;">模板管理</span>
      <div style="display:inline-block;float:right">
        <span style="display: inline-block;width:88px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:rgba(66, 223, 228, 1);border-radius: 4px;font-size:14px;color:#fff;;" @click="createMsgTpl">新建模板</span>
      </div>
    </div>
    <div style="margin-top:20px;">
      <a-row>
        <a-col :span="6">
          <div style="">
            <div>
              <a-radio-group name="select" :default-value="1" @change="changeSelect" v-model="tplManage">
                <a-radio :value="1">
                  我的
                </a-radio>
                <a-radio :value="2">
                  共享
                </a-radio>
              </a-radio-group>
            </div>
          </div>
        </a-col>
      </a-row>
    </div>
    <div style="margin-top:24px;">
      <a-table
        :data-source="sendMsgRecord"
        :pagination="false"
        :scroll="{ y: 'calc(100vh - 390px)' }"
        :rowKey="record => record.id"
        tableLayout="fixed"
      >
        <!-- ID / 序号 -->
        <a-table-column
          key="fengxinTemplateId"
          title="模板ID"
          data-index="fengxinTemplateId"
          width="6%"
        />

        <!-- 模板内容 -->
        <a-table-column
          key="showContent"
          title="模板内容"
          data-index="showContent"
          width="59%"
        >
          <template slot-scope="text, record">
            <div class="content-cell">
              <span v-html="record.showContent"></span>
            </div>
          </template>
        </a-table-column>

        <!-- 状态 -->
        <a-table-column
          key="status"
          title="状态"
          data-index="status"
          width="7%"
        >
          <template slot-scope="text, record">
            <span style="color:#79889B;">
              {{ record.status == 1 ? '审核中' : record.status == 2 ? '正常' : '失效' }}
            </span>
          </template>
        </a-table-column>

        <!-- 创建时间 -->
        <a-table-column
          key="createTime"
          title="创建时间"
          data-index="createTime"
          width="15%"
        />

        <a-table-column
          key="shareStatus"
          title="是否共享"
          data-index="shareStatus"
          width="7%"
        >
          <template slot-scope="text, record">
            <a-switch
              :checked="record.shareStatus == 2"
              @change="checked => changeShare1(checked, record)"
            />
          </template>
        </a-table-column>

        <!-- 操作 -->
        <a-table-column
          key="isDelete"
          title="操作"
          width="7%"
        >
          <template slot-scope="text, record">
            <span
              @click="deleteTplItem(record.id)"
              style="color:#79889B;cursor:pointer"
            >
              删除
            </span>
          </template>
        </a-table-column>
      </a-table>

      <div class="pagination-table">
          <a-pagination
              class="pagination"
              show-size-changer
              :default-current="1"
              :total="total"
              @change="pageChange"
              @showSizeChange="onShowSizeChange"
          />
      </div>
    </div>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="reportMsgModal" title="创建短信模板" footer='' width='560px'>
      <div class="record-modal modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div style="display: flex;">
          <span style="float: left;margin-top:6px;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">选择签名：</span>
          <div style="flex:1">
            <div>
              <a-radio-group style="margin-top:6px;" v-model="msgTplSign" @change="changeShareType1">
                <a-radio :value="1">
                  我的
                </a-radio>
                <a-radio :value="2">
                  共享
                </a-radio>
              </a-radio-group>
              <span @click="goReport" style="display: inline-block;width:128px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(66, 223, 228, 1);color:#fff;float: right;">没有签名，去报备</span>
            </div>
            <a-select placeholder="请选择" style="width: 100%;margin-top:8px;margin-right:60px;" label-in-value @change="changeSign" v-model="signValue1">
              <a-select-option :value="item.id" v-for="(item,index) in reportingManagement1" :key="index">
                {{item.content}} 
              </a-select-option>
            </a-select>
          </div>
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">短信内容：</span>
          <div style="flex:1">
            <div>

              <div
                ref="editor"
                class="editor"
                contenteditable="true"
                @input="handleInput"
                @click="saveSelection"
                @keyup="saveSelection"
              >
              </div>
            </div>


            <div style="margin-top:8px;">
              <span @click="insertVariable" style="display: inline-block;width:84px;height:28px;line-height: 28px;text-align: center;cursor: pointer;background:rgba(66, 223, 228, 1);border-radius: 4px;font-size:14px;color:#fff;">插入变量值</span>
              <span @click="insertDomain" style="display: inline-block;width:84px;height:28px;line-height: 28px;text-align: center;cursor: pointer;background:rgba(24, 144, 255, 1);border-radius: 4px;font-size:14px;color:#fff;margin:0 8px;">插入域名</span>
              <span @click="insertPhone" style="display: inline-block;width:102px;height:28px;line-height: 28px;text-align: center;cursor: pointer;background:rgba(24, 144, 255, 1);border-radius: 4px;font-size:14px;color:#fff;">插入联系号码</span>
            </div>
          </div>
        </div>
        <div style="display: flex;margin-top:16px;">
          <div style="display: inline-block;font-size:14px;width:75px;;">
            <div style="color:rgba(18, 18, 18, 1);">预览短信：</div>
            <div style="color:rgba(158, 172, 196, 1);margin-top:11px;font-size:12px;">
              <span>预计</span>
              <span v-if="currentMsgTplSign.length!=0">{{message.length + 6 + currentMsgTplSign.length}}</span>
              <span v-if="currentMsgTplSign.length==0">{{message.length + 6}}</span>
              <span>个字符</span>
            </div>
          </div>
          <!-- <a-textarea placeholder="请输入" style="height: 180px;resize: none;flex: 1;" /> -->
          <div style="height: 180px;border:1px solid rgba(121, 136, 155, 0.3);color:rgba(80, 80, 80, 1);font-size:14px;border-radius: 4px;padding:6px 10px;flex:1">
            <span v-if="currentMsgTplSign.length!=0">{{currentMsgTplSign}}</span>
            <span>{{ message }}</span>
            <span>拒收请回复R</span>
          </div>
        </div>
        <div style="display: flex;margin-top:16px;">
          <span style="float: left;width:75px;color:rgba(18, 18, 18, 1);font-size:14px;">私有公开：</span>
          <a-switch @change="changeShare2" v-model="isPrivate" />
          <span style="color:rgba(121, 136, 155, 1);font-size:14px;margin-left:8px;">{{isPrivate==true?'公开':'私有'}}</span>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelMsg">取消</a-button>
          <a-button type="primary" @click="sureMsg">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="variableModal" title="插入变量值" footer='' width='440px'>
      <div class="record-modal modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-top:18px">输入变量值名称：</div>
        <a-input v-model="variableKey" placeholder="请输入" />
        <div style="color:rgba(18, 18, 18, 1);font-size:14px;margin-top:16px;">数据示例：</div>
        <a-input v-model="variableValue" placeholder="请输入" />
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelVariable">取消</a-button>
          <a-button type="primary" @click="sureVariable">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="domainModal" title="插入域名" footer='' width='440px'>
      <div class="record-modal modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div style="margin-top:18px;">
          <span style="color:rgba(18, 18, 18, 1);font-size:14px;">选择域名：</span>
          <a-radio-group v-model="selectedDomain" @change="changeShareType2($event, 3)">
            <a-radio :value="1">
              我的
            </a-radio>
            <a-radio :value="2">
              共享
            </a-radio>
          </a-radio-group>
        </div>
        <a-select placeholder="请选择" style="width: 100%;margin-top:10px;" v-model="signValue2">
          <a-select-option :value="item.content" v-for="(item,index) in reportingManagement2" :key="index">
            {{item.content}} 
          </a-select-option>
        </a-select>
        <div style="margin-top:8px;">
          <span @click="goReport" style="display: inline-block;width:128px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(66, 223, 228, 1);color:#fff;">没有域名，去报备</span>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelDomain">取消</a-button>
          <a-button type="primary" @click="sureDomain">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="phoneModal" title="插入联系号码" footer='' width='440px'>
      <div class="record-modal modal-public">
        <a-divider style="margin:0 0 12px 0;" type="horizontal" />
        <div style="margin-top:18px;">
          <span style="color:rgba(18, 18, 18, 1);font-size:14px;">选择号码：</span>
          <a-radio-group v-model="selectedDomain" @change="changeShareType2($event, 2)">
            <a-radio :value="1">
              我的
            </a-radio>
            <a-radio :value="2">
              共享
            </a-radio>
          </a-radio-group>
        </div>
        <a-select placeholder="请选择" style="width: 100%;margin-top:10px;" v-model="signValue2">
          <a-select-option :value="item.content" v-for="(item,index) in reportingManagement2" :key="index">
            {{item.content}} 
          </a-select-option>
        </a-select>
        <div style="margin-top:8px;">
          <span @click="goReport" style="display: inline-block;width:128px;height:32px;line-height: 32px;text-align: center;cursor: pointer;background:#fff;border-radius: 4px;background: rgba(66, 223, 228, 1);color:#fff;">没有号码，去报备</span>
        </div>
        <a-divider class="divider2" type="horizontal" />
        <div class="btn-group">
          <a-button type="primary" ghost @click="cancelPhone">取消</a-button>
          <a-button type="primary" @click="surePhone">确定</a-button>
        </div>
      </div>
    </a-modal>
    <a-modal :centered='true' :maskClosable='false' v-model.trim="deleteBool" footer='' width='480px'>
      <div class="delete-modal modal-public">
          <div class="sure-off-bind">
              <a-icon type="warning" />
              <span>您确定要删除该模板吗？</span>
          </div>
          <div class="tip">删除后，无法恢复</div>
          <a-divider class="divider2" type="horizontal" />
          <div class="btn-group">
              <a-button type="primary" ghost @click="cancelDelete">取消</a-button>
              <a-button type="primary" @click="sureDelete">确定</a-button>
          </div>
      </div>
    </a-modal>
  </div>
</template>

<script> 
export default {
  name: 'TemplateManagement',
  data() {
    return {
      ifShowLoading: false,
      total: 0,
      sendMsgRecord: [],
      currentPage: 1,
      pageSize: 10,
      reportMsgModal: false,
      isPrivate: false,
      variableModal: false,
      domainModal: false,
      phoneModal: false,
      name: 'hjkhkj',
      savedRange: null,
      message: '',
      variableKey: '',
      variableValue: '',
      passToService: '',
      domainSelected: undefined,
      phoneSelected: undefined,
      msgTplSign: 1,
      selectedDomain: 1,
      selectedPhone: 1,
      currentMsgTplSign: '',
      signValue1: undefined,
      tplManage: 1,
      deleteBool: false,
      currentTplId: '',
      reportingManagement1: [],
      reportingManagement2: [],
      signValue2: undefined,
      signHtml: '',
    }
  },
//   computed: {
//     messageWatcher() {
//       console.log(this.$refs.editor.innerHTML);
//       return this.$refs.editor.innerHTML
//  // 返回的值可以是任何东西，这里只是为了触发依赖更新
//     }
//   },
  methods: {
    pageChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryTplList()
    },
    onShowSizeChange(current, pageSize) {
      this.currentPage = current
      this.pageSize = pageSize
      this.queryTplList()
    },
    changeSelect(e) {
      this.currentPage = 1
      this.pageSize = 10
      this.tplManage = e.target.value
      this.queryTplList()
    },
    createMsgTpl() {
      this.reportMsgModal = true
      this.msgTplSign = 1
      this.querySelectList1()
      setTimeout(()=>{
        const editor = this.$refs.editor
        editor.innerHTML = ''
        // 2️⃣ 清空预览
        this.message = ''
        // 3️⃣ 清空提交值
        this.passToService = ''
        // 4️⃣ 清空光标缓存（非常重要）
        this.savedRange = null
        this.msgTplSign = 1
        this.isPrivate = false
        this.signValue1 = undefined
      },200)

    },
    cancelMsg() {
      this.reportMsgModal = false
    },
    sureMsg() {
      this.passToService = this.currentMsgTplSign+this.passToService+'拒收请回复R'
      // console.log(this.passToService)
      // console.log(this.$refs.editor.innerHTML)
      this.reportMsgModal = false
      this.axios.post('/api/templateManagement/saveTemplate', {
        reportingSignId: this.signValue1.key,
        showContent: this.$refs.editor.innerHTML,
        sendContent: this.passToService,
        shareStatus: this.isPrivate?2:1,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.currentPage = 1
          this.pageSize = 10
          this.tplManage = 1
          this.queryTplList()
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    changeShare2(checked) {
      // console.log(`a-switch to ${checked}`);
      this.isPrivate = checked
    },
    insertVariable() {
      this.variableKey = ''
      this.variableValue = ''
      this.variableModal = true
    },
    cancelVariable() {
      this.variableModal = false
    },
    sureVariable() {
      if(this.variableKey!=''&&this.variableValue!=''){
        this.insertAtom(this.variableKey, this.variableValue, 'atom1', 1)
      }
      this.variableModal = false
    },
    insertDomain() {
      this.domainSelected = undefined
      this.selectedDomain = 1
      this.reportingManagement2 = []
      this.signValue2 = undefined
      this.domainModal = true
      this.querySelectList2(3)
    },
    cancelDomain() {
      this.domainModal = false
    },
    sureDomain() {
      if(this.signValue2!=''&&this.signValue2!=undefined){
        this.insertAtom(this.signValue2, this.signValue2, 'atom2', 3)
      }
      this.domainModal = false
    },
    insertPhone() {
      this.phoneSelected = undefined
      this.selectedPhone = 1
      this.reportingManagement2 = []
      this.signValue2 = undefined
      this.selectedDomain = 1
      this.phoneModal = true
      this.querySelectList2(2)
    },
    cancelPhone() {
      this.phoneModal = false
    },
    surePhone() {
      if(this.signValue2!=''&&this.signValue2!=undefined){
        this.insertAtom(this.signValue2, this.signValue2, 'atom2', 2)
      }
      this.phoneModal = false
    },

    // 保存当前光标位置
    saveSelection() {
      const selection = window.getSelection()
      if (selection && selection.rangeCount > 0) {
        this.savedRange = selection.getRangeAt(0)
      }
    },

    // 插入整体节点
    insertAtom(key, value, classname, type) {
      const editor = this.$refs.editor
      editor.focus()

      let range = this.savedRange
      const selection = window.getSelection()

      if (!range) {
        range = document.createRange()
        range.selectNodeContents(editor)
        range.collapse(false)
      }

      const span = document.createElement('span')
      span.className = classname
      span.contentEditable = 'false'
      span.dataset.key = key
      span.dataset.value = value
      span.dataset.type = type
      span.innerText = `${key}`

      range.insertNode(span)
      range.setStartAfter(span)
      range.setEndAfter(span)

      selection.removeAllRanges()
      selection.addRange(range)
      this.savedRange = range

      this.syncValue()
    },
     // 监听富文本变化
    handleInput() {
      this.syncValue()
    },

    syncValue() {
      const editor = this.$refs.editor
      const clone = editor.cloneNode(true)

      // 编辑态（给后端）
      clone.querySelectorAll('.atom1, .atom2').forEach(span => {
        // console.log(span)
        // span.replaceWith(`{{${span.dataset.key}}}`)
        // span.replaceWith(`${span.dataset.key}`)
        const key = span.dataset.key
        if (span.classList.contains('atom1')) {
          span.replaceWith(`{%${key}%}`)
        } else if (span.classList.contains('atom2')) {
          span.replaceWith(`${key}`)
        }
      })
      this.passToService = clone.innerText
      // console.log(this.passToService)

      const previewClone = editor.cloneNode(true)
      previewClone.querySelectorAll('.atom1, .atom2').forEach(span => {
        span.replaceWith(span.dataset.value)
      })
      this.message = previewClone.innerText
    },
    goReport() {
      this.$parent.selectNav('ReportingManagement')
      this.$router.push("/ReportingManagement")
    },
    changeSign(option) {
      this.currentMsgTplSign = option.label.trim()
      // console.log(this.currentMsgTplSign)
    },
    queryTplList() {
      this.axios(
        {
          method:'get',
          url:'/api/templateManagement/list', 
          params: {
            current: this.currentPage,
            size: this.pageSize,
            shareStatus: this.tplManage,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.sendMsgRecord = response.data.data.records
          this.total = response.data.data.total
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    deleteTplItem(id) {
      this.currentTplId = id
      this.deleteBool = true
    },
    cancelDelete() {
      this.deleteBool = false
    },
    sureDelete() {
      this.deleteBool = false
      this.axios.post('/api/templateManagement/delete', {
        id: this.currentTplId,
      })
      .then(response=> {
        if(response.data.code == 0){
          this.currentPage = 1
          this.queryTplList()
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
    changeShareType1(e) {
      this.msgTplSign = e.target.value
      this.signValue1 = undefined
      this.querySelectList1()
    },
    querySelectList1() {
      this.axios(
        {
          method:'get',
          url:'/api/reportingManagement/selectList', 
          params: {
            shareStatus: this.msgTplSign,
            type: 1,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.reportingManagement1 = response.data.data
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    changeShareType2(e, type) {
      this.selectedDomain = e.target.value
      this.signValue2 = undefined
      this.querySelectList2(type)
    },
    querySelectList2(type) {
      this.axios(
        {
          method:'get',
          url:'/api/reportingManagement/selectList', 
          params: {
            shareStatus: this.selectedDomain,
            type: type,
          }
        }
      )
      .then(response=> {
        if(response.data.code == 0){
          this.reportingManagement2 = response.data.data
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
          console.log(error)
      })
    },
    changeShare1(checked, record) {
      // this.record.shareStatus = checked ? 1 : 2
      this.axios.post('/api/templateManagement/updateShareStatus', {
        id: record.id,
        shareStatus: checked ? 2 : 1
      })
      .then(response=> {
        if(response.data.code == 0){
          this.queryTplList()
        }else{
          this.$message.error(response.data.userTip);
        }
      })
      .catch(error=> {
        console.log(error);
      });
    },
  },
  mounted: function() {
    this.sessionData('set','contentNavItem','TemplateManagement');
    this.queryTplList()
  }
}
</script>

<style lang="less">
  .pagination-table{
    padding-top: 24px;
    text-align: right;
  }
  .modal-public{
    .divider1{
        margin: 0px 0 24px 0;
    }
    .divider2{
        margin: 24px 0 12px;
    }
    .btn-group{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          margin-right: 16px;
      }
    }
    .btn-group2{
      float: right;
      button{
          // width: 64px;
          height: 32px;
          font-size: 14px;
      }
      button:nth-child(1){
          background: #fff;
          color: rgba(121, 136, 155, 0.7);
          border: 1px solid rgba(121, 136, 155, 0.5);
          margin-right: 16px;
      }
      button:nth-child(1):hover{
          background: rgba(121, 136, 155, 0.08);
      }
    }
  }
  .record-modal{
    padding-bottom: 44px;
    .changed-name{
      color: rgba(153, 153, 153, 1);
      font-size: 14px;
    }
    input{
      margin-top: 8px;
    }
  }
  .editor {
    min-height: 80px;
    border: 1px solid rgba(121, 136, 155, 0.3);
    padding: 6px;
  }

  .atom1 {
    display: inline-block;
    background: rgba(179, 184, 193, 0.2);
    padding: 2px 6px;
    border-radius: 4px;
    color:rgba(66, 223, 228, 1);
    font-size: 14px;
    user-select: none;
    margin: 0 2px;
  }
  .atom2 {
    display: inline-block;
    background: rgba(179, 184, 193, 0.2);
    padding: 2px 6px;
    border-radius: 4px;
    color:rgba(24, 144, 255, 1);
    font-size: 14px;
    user-select: none;
    margin: 0 2px;
  }
  .delete-modal{
    padding-top: 24px;
    padding-bottom: 44px;
    .sure-off-bind{
        i{
            color: rgba(255, 170, 0, 1);
            font-size: 24px;
        }
        span{
            color: rgba(18, 18, 18, 1);
            font-size: 20px;
            margin-left: 24px;
        }
    }
    .tip{
        color: rgba(80, 80, 80, 1);
        padding-left: 50px;
        margin: 24px 0;
    }
  }
</style>
